"use strict";

exports.__esModule = true;
exports.JSONP_SIGN = exports.CONTAINER_NAME = void 0;
var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram',
  NODE: 'node'
};
exports.CONTAINER_NAME = CONTAINER_NAME;
var JSONP_SIGN = '__uni_jsonp_handler_sign__';
exports.JSONP_SIGN = JSONP_SIGN;